import { v } from '../validation'

// Define the schema for the Osprey API
// exported here for reuse in multiple places, and to enable changing the validation library in the future
export const ospreyLoginSchema = v.object({
  userIdOrEmailAddress: v.string('Invalid username parameter').required(),
  password: v.string('Invalid password parameter').required(),
  companyCode: v.string('Invalid companyCode parameter').required(),
  databaseSuffix: v.string('Invalid databaseSuffix parameter').required()
})

export const ospreyRequestPasswordResetSchema = v.object({
  userIdOrEmailAddress: v.string('Invalid username parameter').required(),
  companyCode: v.string('Invalid companyCode parameter').required(),
  databaseSuffix: v.string('Invalid databaseSuffix parameter').required()
})

const getPasswordResetSchema = (length) => {
  return v.object({
    newPassword: v
      .string('Invalid password')
      .min(length, `Must be at least ${length} characters`)
      .matches(/^(?=.*[A-Z])/, 'Must contain an uppercase character')
      .matches(/^(?=.*[a-z])/, 'Must contain an lowercase character')
      .matches(/^(?=.*[0-9])/, 'Must contain a number')
      .matches(/^(?=.*[^\w\s"])/, 'Must contain a special character')
      .required(),
    userId: v.string('Invalid userId parameter'),
    passwordResetToken: v.string('Invalid passwordResetToken parameter').required()
  })
}

export let ospreyCompletePasswordResetSchema = getPasswordResetSchema(8)

export let ospreyPasswordHasSufficientLength = v.object({
  password: v.string('Invalid newPassword parameter').min(8).required()
})

export const setMinimumPasswordLength = (length) => {
  ospreyPasswordHasSufficientLength = v.object({
    password: v.string('Invalid newPassword parameter').min(length).required()
  })

  ospreyCompletePasswordResetSchema = getPasswordResetSchema(length)
}

export const ospreyPasswordHasUppercase = v.object({
  password: v
    .string('Invalid newPassword parameter')
    .matches(/^(?=.*[A-Z])/, 'Must contain an uppercase character')
    .required()
})

export const ospreyPasswordHasLowercase = v.object({
  password: v
    .string('Invalid newPassword parameter')
    .matches(/^(?=.*[a-z])/, 'Must contain a lowercase character')
    .required()
})

export const ospreyPasswordHasNumber = v.object({
  password: v
    .string('Invalid newPassword parameter')
    .matches(/^(?=.*[0-9])/, 'Must contain a number')
    .required()
})

export const ospreyPasswordHasSpecialCharacter = v.object({
  password: v
    .string('Invalid newPassword parameter')
    .matches(/^(?=.*[^\w\s"])/, 'Must contain a special character')
    .required()
})

export const ospreySearchSchema = v.object({
  SearchTerm: v.string('Invalid SearchTerm parameter'),
  StartAtIndex: v.number('Invalid StartAtIndex parameter'),
  PageSize: v.number('Invalid PageSize parameter')
})

export const ospreyRecentMattersSchema = v.object({
  startAtIndex: v.number('Invalid startAtIndex parameter'),
  pageSize: v.number('Invalid pageSize parameter')
})

export const ospreyMatterSchema = v.object({
  ClientNo: v.string('Invalid clientNo parameter').required(),
  MatterNo: v.mixed('Invalid matterNo parameter').required()
})

export const ospreyClientSchema = v.object({
  clientNo: v.string('Invalid clientNo parameter').required()
})

export const ospreyKpiChartSchema = v.object({
  feeEarnerIds: v.string('Invalid feeEarnerIds parameter').required()
})

export const ospreyUpcomingDatesSchema = v.object({
  IncludeMattersForReview: v.boolean('Invalid IncludeMattersForReview parameter'),
  KeyDateAddedByUser: v.boolean('Invalid KeyDateAddedByUser parameter'),
  KeyDateAssignedToUser: v.boolean('Invalid KeyDateAssignedToUser parameter'),
  KeyDateRedirectedToUser: v.boolean('Invalid KeyDateRedirectedToUser parameter'),
  KeyDatesForSupervisingFeeEarner: v.boolean('Invalid KeyDatesForSupervisingFeeEarner parameter'),
  StartAtIndex: v.number('Invalid StartAtIndex parameter'),
  PageSize: v.number('Invalid PageSize parameter'),
  OrderByColumns: v.array(v.string('Invalid OrderByColumns parameter'))
})

export const ospreyFetchAllTimersSchema = v.object({
  startAtIndex: v.number('Invalid startAtIndex parameter').required(),
  pageSize: v.number('Invalid pageSize parameter').required(),
  clientNo: v.string('Invalid clientNo parameter'),
  matterNo: v.mixed('Invalid matterNo parameter'),
  endDate: v.string('Invalid endDate parameter').required()
})

export const ospreyFetchAllPostingsSchema = v.object({
  startAtIndex: v.number('Invalid startAtIndex parameter').required(),
  pageSize: v.number('Invalid pageSize parameter').required(),
  clientNo: v.string('Invalid clientNo parameter'),
  matterNo: v.mixed('Invalid matterNo parameter'),
  postingDate: v.string('Invalid postingDate parameter').required()
})

export const ospreyMatterWorkflowSchema = v.object({
  workflowId: v.number('Invalid workflowId parameter'),
  description: v.string('Invalid description parameter'),
  workTypeId: v.string('Invalid workTypeId parameter'),
  matterWorkflowWorkTypeTasks: v.array(
    v.object({
      matterWorkflowWorkTypeTaskId: v.number('Invalid matterWorkflowWorkTypeTaskId parameter'),
      clientNo: v.string('Invalid clientNo parameter'),
      matterNo: v.number('Invalid matterNo parameter'),
      positionIndex: v.number('Invalid positionIndex parameter'),
      workflowId: v.number('Invalid workflowId parameter'),
      matterWorkflowWorkTypeIdCount: v.number('Invalid matterWorkflowWorkTypeIdCount parameter'),
      workTypeTaskId: v.number('Invalid workTypeTaskId parameter'),
      completedDate: v.string('Invalid completedDate parameter'),
      indentation: v.number('Invalid indentation parameter'),
      workflowSectionId: v.number('Invalid workflowSectionId parameter'),
      workflowSectionPositionIndex: v.number('Invalid workflowScetionPositionIndex parameter')
    })
  )
})
